
















































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  ListResult,
  ListParameters,
  TimeEntryFilter,
  TimeEntryGroupingModel,
  TimeEntryListSettingsModel,
  ListPresetEditModel,
  ListPresetViewModel,
  ListPresetListViewModel,
  DeleteResultModel,
  TimeEntryFilterTimeFrame
} from "@/services/api/nswag/stapiclient_generated";
import { stListApi, stTimeEntryApi } from "@/services/st-api";
import StInput2 from "@/components/basic/StInput2.vue";
import TimeEntryFilterComponent from "@/components/timeentry-filter/TimeEntryFilterComponent.vue";
import TimeEntryGrouper from "@/components/timeentry-filter/TimeEntryGrouper.vue";
import SlideIn from "@/components/basic/SlideIn.vue";
import { notifyDeletion, notifySuccess } from "@/utlitities/notifications";
import { DateTime } from "luxon";
//@ts-ignore
import * as FileSaver from "file-saver";
import ListTable from "@/views/List/ListTable.vue";
import { UserStore } from "@/store/user-module";
import ListColumnEdit from "@/views/List/ListColumnEdit.vue";

Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  components: { SlideIn, TimeEntryGrouper, TimeEntryFilterComponent, StInput2, ListTable, ListColumnEdit }
})
export default class List extends Vue {
  filter: TimeEntryFilter = this.defaultFilter;
  private grouping: TimeEntryGroupingModel | null | undefined = TimeEntryGroupingModel.fromJS({});
  private listSettings: TimeEntryListSettingsModel | null | undefined = TimeEntryListSettingsModel.fromJS({});
  private listSettingsWork: TimeEntryListSettingsModel | null | undefined = TimeEntryListSettingsModel.fromJS({ alignLandscape: false });

  private listResult: ListResult | null = null;

  private reportName: string = "";

  private savedReports: ListPresetListViewModel[] = [];
  private currentReport: ListPresetViewModel = new ListPresetViewModel();
  pdfLoading = false;
  excelLoading = false;
  toggleClearedLoadingId = 0;
  deleteLoadingId = 0;
  saveListPresetLoading = false;
  filterLoading = false;
  showSavedReports = false;

  loading = true;
  delayLoading = false;
  dirty = false;
  filterWatcher: any;
  groupingWatcher: any;
  settingsWatcher: any;
  filterSelectVisible = true;

  get defaultFilter(){
    return TimeEntryFilter.fromJS({
      timeframe: TimeEntryFilterTimeFrame.ThisMonth,
      customerIds: [],
      projectIds: [],
      projectTaskIds: [],
      appUserIds: [],
      tagIds: [],
      ids: [],
      extraFields: [],
    })
  }

  //hier gehts wohl los ... wahrscheinlich ;)
  async filterLoaded() {
    this.loading = true;
    const listParameters = await stListApi.getDefaultListParams();
    this.grouping = listParameters.grouping!;
    //TODO: aus Gründen geht das nicht .. invalid datetime mal fixen
    // this.filter = listParameters.filter!;
    this.listSettings = listParameters.listSettingsModel!;

    await this.loadListPresets();
    let defaultReport = this.savedReports.find((_) => _.isDefault);

    if (defaultReport) {
      await this.changeReport(defaultReport.id!);
    }

    this.filterLoading = false;
    await this.applyFilter();
    this.loading = false;
    await this.$nextTick();
    //TODO: wird zwei mal aufgerufen ...
    if(!this.filterWatcher){
      this.watchFilterChanges();
    }

  }

  beforeDestroy() {
    this.unwatchFilterChanges();
  }

  watchFilterChanges() {
    this.filterWatcher = this.$watch("filter", () => {
      this.dirty = true;
    }, { deep: true });

    this.groupingWatcher = this.$watch("grouping", () => {
      this.dirty = true;
    }, { deep: true });

    this.settingsWatcher = this.$watch("listSettings", () => {
      this.dirty = true;
    }, { deep: true });
  }

  async unwatchFilterChanges() {
    if (this.filterWatcher)
      await this.filterWatcher();
    if (this.groupingWatcher)
      await this.groupingWatcher();
    if (this.settingsWatcher)
      await this.settingsWatcher();
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (to.name == "List") {
      this.loadData();
    }
  }

  toggleDateSort(){
    this.listSettings!.sortDateAscending = !this.listSettings!.sortDateAscending;
    this.applyFilter();
  }

  get useProjectTimeTracking(){
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
  }

  async loadListPresets() {
    this.savedReports = await stListApi.getListPresets();
  }

  get reportSelected() {
    return this.currentReport.id;
  }

  get userNowDateTime() {
    return DateTime.fromISO(UserStore.userSettings.userNowDateTime);
  }

  get accountIsLocked() {
    return UserStore.userSettings.accountIsLocked;
  }

  async createNewReport() {
    await this.unwatchFilterChanges();
    await this.$nextTick();
    const listParams = await stListApi.getDefaultListParams();
    this.grouping = listParams.grouping;
    this.listSettings = listParams.listSettingsModel;
    this.filter = listParams.filter;
    this.listSettingsWork = TimeEntryListSettingsModel.fromJS({ alignLandscape: false });
    this.currentReport = ListPresetViewModel.fromJS({});
    await this.$nextTick();
    this.watchFilterChanges();
    this.dirty = false;
  }

  private multiTimeout: any;

  async applyFilter() {
    if (this.filterLoading) {
      return;
    }

    if (this.multiTimeout) {
      clearTimeout(this.multiTimeout);
    }

    this.multiTimeout = setTimeout(async () => {
      this.loading = true;
      try {
        await this.loadData();
      } finally {
        this.loading = false;
      }
    }, 20);
  }

  async applyGrouping(grouping: TimeEntryGroupingModel) {
    try {
      this.loading = true;
      this.grouping = grouping;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  copySuccess() {
    notifySuccess("Erfolgreich kopiert");
  }

  editTimeEntry(id: number) {
    if (id == 0) {
      //check if current date is within filter, if not use entryDateTo of Filter
      let newEntryDate = this.userNowDateTime;
      let filterTo = DateTime.fromISO(this.filter.entryDateTo!.toString());

      if (newEntryDate > filterTo) {
        newEntryDate = filterTo;
      }

      this.$router.push({
        name: "ListTimeEntryEdit",
        params: { id: id.toString(), entryDate: newEntryDate.toFormat("yyyy-MM-dd") }
      });
    } else {
      this.$router.push({ name: "ListTimeEntryEdit", params: { id: id.toString() } });
    }
  }

  get params() {
    return ListParameters.fromJS({
      filter: this.filter,
      grouping: this.grouping,
      listSettingsModel: this.listSettings
    });
  }

  async loadData() {
    this.delayLoading = true;
    const result = await stListApi.get(this.params);
    this.listResult = Object.freeze(result);
    this.delayLoading = false;
  }

  get alignment(): any[] {
    return [
      { id: false, text: "Hochformat" },
      { id: true, text: "Querformat" }
    ];
  }

  async exportPdf() {
    try {
      this.pdfLoading = true;
      let result = await stListApi.generatePdf(this.$t("Leistungsnachweis").toString(), this.params);
      FileSaver.saveAs(result.data, this.$t("Leistungsnachweis").toString() + ".pdf");
    } finally {
      this.pdfLoading = false;
    }
  }

  async exportExcel() {
    try {
      this.excelLoading = true;
      let result = await stListApi.exportExcel(this.params);
      FileSaver.saveAs(result.data, "SpikeTime_Export.xlsx");
    } finally {
      this.excelLoading = false;
    }
  }

  openSettings() {
    this.listSettingsWork = JSON.parse(JSON.stringify(this.listSettings));
    (this.$refs.settings as SlideIn).open();
  }

  saveSettings() {
    this.listSettings = JSON.parse(JSON.stringify(this.listSettingsWork));
    (this.$refs.settings as SlideIn).close();
    this.loadData();
  }

  cancelSettings() {
    (this.$refs.settings as SlideIn).close();
  }

  openColumnEdit() {
    (this.$refs.columns as any).openSlideIn();
  }

  openSaveReport() {
    (this.$refs.savereport as SlideIn).open();
    setTimeout(() => {
      document.getElementById("reportName")!.focus();
    }, 300);
  }

  async toggleCleared(id: number) {
    try {
      this.toggleClearedLoadingId = id;
      let isCleared = await stTimeEntryApi.toggleCleared(id);

      if (isCleared) {
        notifySuccess("Zeiteintrag abgeschlossen");
      } else {
        notifySuccess("Zeiteintrag geöffnet");
      }

      await this.loadData();
    } finally {
      this.toggleClearedLoadingId = 0;
    }
  }

  async toggleClearedAll(newvalue: boolean) {
    try {
      this.loading = true;
      await stListApi.toggleClearedAll(newvalue, this.filter);

      if (newvalue) {
        notifySuccess("Zeiteinträge abgeschlossen");
      } else {
        notifySuccess("Zeiteinträge geöffnet");
      }

      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async saveListPreset() {
    try {
      this.saveListPresetLoading = true;
      this.filterSelectVisible = false;
      let listPreset = new ListPresetEditModel();
      listPreset.id = this.currentReport.id;
      listPreset.name = this.currentReport.name;
      listPreset.isDefault = this.currentReport.isDefault;
      listPreset.isExternalAccess = this.currentReport.isExternalAccess;

      listPreset.listParameters = ListParameters.fromJS({
        filter: this.filter,
        grouping: this.grouping,
        listSettingsModel: this.listSettings
      });
      const id = await stListApi.saveListPreset(listPreset);
      await this.loadListPresets();
      this.currentReport = await stListApi.getListPreset(id);
      notifySuccess("Erfolgreich gespeichert");
      this.dirty = false;
    } finally {
      this.saveListPresetLoading = false;
      this.filterSelectVisible = true;
    }

    (this.$refs.savereport as SlideIn).close();
  }

  async changeReport(listPresetId: number) {
    await this.unwatchFilterChanges();
    await this.$nextTick();
    this.currentReport = await stListApi.getListPreset(listPresetId);
    this.filter = this.currentReport.listParameters?.filter ?? this.defaultFilter;
    this.grouping = this.currentReport.listParameters!.grouping;
    this.listSettings = this.currentReport.listParameters!.listSettingsModel;
    this.reportName = this.currentReport.name!;
    await this.$nextTick(); // wird benötigt, damit der Filter einen eventuell gesetzten Date TimeFrame noch richtig setzen kann, bevor die Daten geladen werden
    this.watchFilterChanges();
    this.dirty = false;
  }

  async deleteListPreset(listPresetId: number) {
    await stListApi.deleteListPreset(listPresetId);
    await this.loadListPresets();

    if (this.currentReport && this.currentReport.id == listPresetId) {
      this.currentReport = new ListPresetEditModel();
    }
  }

  cancelListPreset() {
    (this.$refs.savereport as SlideIn).close();
  }

  async undoDeletion(id: number) {
    await stTimeEntryApi.undelete(id);
    await this.loadData();
    notifySuccess("Zeiteintrag wiederhergestellt.");
  }

  async deleteItem(id: number): Promise<DeleteResultModel> {
    try {
      this.deleteLoadingId = id;
      const resp = await stTimeEntryApi.delete(id, true);
      notifyDeletion(async () => this.undoDeletion(id));
      await this.loadData();
      return resp;
    } finally {
      this.deleteLoadingId = 0;
    }
  }
}
